import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as cartActions } from '@/reducers/cart';
import { COLORS } from '@gc-npm/utils.enums.colors';
import { getModuleNamesTagginInfo } from '@/utils/index';
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_SIZE,
} from '@gc-npm/components.text';
import Button, { BUTTON_WIDTH } from '@gc-npm/components.button';
import ShoppingCartBottom from '@/components/ShoppingCart/ShoppingCartBottom';
import ShoppingCartModuleList from '@/components/ShoppingCart/ShoppingCartModuleList';
import ShoppingCart900 from '@/components/ShoppingCart/ShoppingCart900';
import { API_STATUS, LAYOUT_TYPES, SCREEN_TYPES } from '@/utils/constants';

const ShoppingCart = ({
  title,
  titleOnlyTv,
  buttonTextDestkop,
  modulos,
  prices,
  legalText,
  legalTextNoClte,
}) => {
  const dispatch = useDispatch();
  const screenType = useSelector((state) => state.UI.screenType);
  const layout = useSelector((state) => state.UI.layout);
  const clientModules = useSelector((state) => state.client.modulos);
  const statusModulos = useSelector((state) => state.modulos.statusModulos);
  const statusSelection = useSelector((state) => state.modulos.statusSelection);
  
  if (!modulos) {
    return null;
  }

  const taggingInfo = {
    componentName: 'ShoppingCart',
    componentProduct: getModuleNamesTagginInfo(modulos, layout, clientModules),
    componentContent: buttonTextDestkop || '',
    componentVariation: '',
  };

  const onClickHandler = () => {
    dispatch(cartActions.purchase());
  };

  const titleShoppingCart = layout === LAYOUT_TYPES.TV ? titleOnlyTv : title;
  const isLoading = statusModulos === API_STATUS.LOADING || statusSelection === API_STATUS.LOADING;
  return (
    <>
      <div className="ShoppingCart">
        <div className="ShoppingCart_header">
          {titleShoppingCart && (
            <TextInfo
              text={titleShoppingCart}
              size={TEXT_SIZE.T6}
              color={TEXT_COLOR.GREY6}
              kind={TEXT_KIND.SPAN}
              fontType={TEXT_FONT_WEIGHT.BOLD}
            />
          )}
        </div>
        <ShoppingCartModuleList
          modulos={modulos}
          isLoading={(statusModulos === API_STATUS.LOADING)}
        />
        <hr />
        <ShoppingCartBottom
          legalText={legalText}
          legalTextNoClte={legalTextNoClte}
          prices={prices}
          isLoading={isLoading}
          modulos={modulos}
        />
        <div className="butonShoppingCart">
          <Button
            label={buttonTextDestkop}
            onClick={onClickHandler}
            disabled={Boolean(isLoading)}
            taggingInfo={taggingInfo}
            width={BUTTON_WIDTH.FULL}
          />
          {screenType === SCREEN_TYPES.DESKTOP && (<ShoppingCart900 />)}
        </div>

      </div>
      <style jsx>
        {`
          .ShoppingCart {
            background-color: ${COLORS.grey100};
            border-radius: 1rem;
            padding: 1rem;
            display: flex;
            flex-direction: column;
            hr {
              width: 100%;
              color: ${COLORS.grey300};
              margin: 0 0 0.75rem 0;
            }
            &_header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-bottom: 1.5rem;
            }
            :global(.ShoppingCart_section) {
              width: 100%;
            }
            &_footer {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;
              gap: 0.5rem;
              &-instalationPrices {
                display: flex;
                align-items: flex-end;
                gap: 1rem;
              }
            }
            .butonShoppingCart{
              padding-top: 1.5rem;
              padding-bottom: 0.5rem;
              }
          }
          @media screen and (max-width: 800px) {
            .ShoppingCart {
              width: 100%;
              position: fixed;
              z-index: 30;
              bottom: 0;
              left: 0;
              border-top: 1px solid ${COLORS.grey300};
              border-radius: 0;
              background-color: ${COLORS.grey200};

              &_footer {
                flex-direction: row;
                :global(.ShoppingCart_footer-expand) {
                  display: flex;
                  gap: 0.5rem;
                  align-items: center;
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default ShoppingCart;
